import { ReportFormatDef } from "../constants";

export interface IReportQueueData {
    reportQueueDataId: number;
    reportTypeId: number;
    reportTypeName: string;
    reportFormat: ReportFormatDef;
    isPending: boolean;
    isProcessing: boolean;
    isDownloadable: boolean;
    hasError: boolean;
    errorMessage: string;
    fileName: string;
    fileSize: string;
    fileExtension: string;
    fileMimeType: string;
    createDatetime: Date;
    expirationDatetime: Date;
}
export class ReportQueueData implements IReportQueueData {
    reportQueueDataId: number;
    reportTypeId: number;
    reportTypeName: string;
    reportFormat: ReportFormatDef;
    isPending: boolean;
    isProcessing: boolean;
    isDownloadable: boolean;
    hasError: boolean;
    errorMessage: string;
    fileName: string;
    fileSize: string;
    fileExtension: string;
    fileMimeType: string;
    createDatetime: Date;
    expirationDatetime: Date;

    constructor(reportQueueData: IReportQueueData) {
        this.reportQueueDataId = reportQueueData.reportQueueDataId;
        this.reportTypeId = reportQueueData.reportTypeId;       
        this.reportTypeName = reportQueueData.reportTypeName;
        this.reportFormat = reportQueueData.reportFormat;
        this.isPending = reportQueueData.isPending;
        this.isProcessing = reportQueueData.isProcessing;
        this.isDownloadable = reportQueueData.isDownloadable;
        this.hasError = reportQueueData.hasError;
        this.errorMessage = reportQueueData.errorMessage;
        this.fileName = reportQueueData.fileName;
        this.fileSize = reportQueueData.fileSize; 
        this.fileExtension = reportQueueData.fileExtension;
        this.fileMimeType = reportQueueData.fileMimeType;
        this.createDatetime = new Date(reportQueueData.createDatetime);
        this.expirationDatetime = new Date(reportQueueData.expirationDatetime);
    }

}
